




























































import { Component, Vue } from "vue-property-decorator";
import Search from "@/components/Search.vue";
import ProposalList from "@/components/sale/list/ProposalList.vue";
import { Action, Getter } from "vuex-class";
import {
  IProposalStatus,
  IProposalStatusListRequest,
} from "@/types/proposalStatus";

@Component({
  components: { ProposalList, Search },
})
export default class extends Vue {
  @Action("proposalStatus/getList")
  public getStatuses!: (params: IProposalStatusListRequest) => Promise<void>;

  @Getter("proposalStatus/list")
  public proposalStatuses!: IProposalStatus[];

  public query = "";
  public status: number | string = "inprogress";

  public dialog = false;
  public member_id = 0;

  public async mounted() {
    await this.getStatuses({ per_page: 0 });
    this.member_id = Number(this.$route.params.member_id);
  }

  public search(): void {
    const target = this.$refs.proposalList as ProposalList;
    this.$nextTick(async () => {
      await target.getList();
    });
  }
}
